import { useNavigate } from '@tanstack/react-router';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useEditorialTeamEdit } from '@/module/Author/EditorialTeam/model/EditorialTeamQuery';
import {
  EditorialTeamSchema,
  defaultEditorialTeamValues,
  editorialTeamSchema,
} from '@/module/Author/EditorialTeam/model/EditorialTeamSchema';

import { useAppNotification } from '@feature/utils';

import { EditorialTeamForm } from './EditorialTeamForm';
import { EditorialTeam } from './model/EditorialTeamTypes';

interface EditorialTeamEditProps {
  editorialTeam: EditorialTeam;
}

const convert = (editorialTeam: EditorialTeam): EditorialTeamSchema => ({
  ...editorialTeam,
});

export function EditorialTeamEdit(props: EditorialTeamEditProps) {
  const { editorialTeam } = props;
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useEditorialTeamEdit(editorialTeam.id);

  const notification = useAppNotification();
  const onSubmit = (values: EditorialTeamSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: notification.success,
    });
  };

  const values = useMemo(() => convert(editorialTeam), [editorialTeam]);
  const navigate = useNavigate();

  return (
    <EditorialTeamForm
      title={t('editorialTeams.form.title.edit')}
      schema={editorialTeamSchema}
      defaultValues={{
        ...defaultEditorialTeamValues,
        type: editorialTeam.type,
      }}
      isError={isError}
      isSuccess={isSuccess}
      values={values}
      onSubmit={onSubmit}
      isSubmitting={isPending}
      onCancel={() => navigate({ to: '..' })}
    />
  );
}
